import React from 'react';
import PageWrapper from '../../components/ui/PageWrapper';
import FadeUp from '../../components/ui/FadeUp';
import CTASection from '../../components/sections/CTASection';
import { Link } from 'react-router-dom';

const commercialTypes = [
  { icon: '🏢', name: 'Offices & Corporate Spaces' },
  { icon: '🛍️', name: 'Retail Shops & Showrooms' },
  { icon: '🏬', name: 'Shopping Complexes' },
  { icon: '🍽️', name: 'Restaurants & Cafés' },
  { icon: '🏨', name: 'Hotels & Resorts' },
  { icon: '💇', name: 'Salons & Wellness Centers' },
  { icon: '🏥', name: 'Clinics & Medical Facilities' },
];

export default function Commercial() {
  return (
    <PageWrapper>
      <section style={{ paddingTop: 140, paddingBottom: 80, background: 'linear-gradient(135deg, #0D0D1F, #1A0F2E)', position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 30% 50%, rgba(201,84,122,0.06) 0%, transparent 60%)' }} />
        <div className="container">
          <FadeUp>
            <p className="section-eyebrow">Services / Commercial</p>
            <h1 className="section-title" style={{ fontSize: 'clamp(2.2rem, 4vw, 3.5rem)' }}>Commercial Vastu</h1>
            <div className="divider" />
            <p style={{ fontSize: 16, opacity: 0.7, maxWidth: 560, lineHeight: 1.8 }}>
              Align your business space for growth, productivity, and success with practical Vastu solutions.
            </p>
          </FadeUp>
        </div>
      </section>

      <section style={{ padding: '80px 0', background: '#0D0D1F' }}>
        <div className="container">
          <FadeUp style={{ marginBottom: 48 }}>
            <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: 28, marginBottom: 16 }}>
              Commercial Properties We Serve
            </h2>
            <p style={{ fontSize: 15, lineHeight: 1.9, opacity: 0.7, maxWidth: 700 }}>
              Commercial spaces carry unique energy patterns that directly impact business performance. Our Vastu consultation helps create an environment that naturally supports growth, prosperity, and success.
            </p>
          </FadeUp>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 20, marginBottom: 64 }}>
            {commercialTypes.map((b, i) => (
              <FadeUp key={i} delay={i * 0.08}>
                <div style={{
                  background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(232,135,26,0.12)',
                  borderRadius: 12, padding: '28px 24px', textAlign: 'center'
                }}>
                  <p style={{ fontSize: 32, marginBottom: 12 }}>{b.icon}</p>
                  <p style={{ fontFamily: 'Playfair Display, serif', fontSize: 15 }}>{b.name}</p>
                </div>
              </FadeUp>
            ))}
          </div>

          <FadeUp>
            <div className="commercial-cta-grid" style={{
              background: 'rgba(232,135,26,0.04)', border: '1px solid rgba(232,135,26,0.15)',
              borderRadius: 16, padding: '48px 40px',
              display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48
            }}>
              <div>
                <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: 22, color: '#E8871A', marginBottom: 20 }}>
                  What We Analyse
                </h3>
                {['Main entrance & reception area', 'Owner/Manager cabin placement', 'Accounts & finance zone', 'Staff seating arrangement', 'Customer-facing areas', 'Storage & inventory zones', 'Signage & branding direction', 'Cash counter & billing area'].map((item, i) => (
                  <div key={i} style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
                    <span style={{ color: '#E8871A' }}>✦</span>
                    <span style={{ fontSize: 14, opacity: 0.75 }}>{item}</span>
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 20 }}>
                <p style={{ fontSize: 15, lineHeight: 1.8, opacity: 0.7 }}>
                  Ready to align your business space for growth and success? Book a commercial Vastu consultation today.
                </p>
                <Link to="/contact" className="btn-primary" style={{ display: 'inline-block', textAlign: 'center' }}>
                  Book Commercial Consultation
                </Link>
              </div>
            </div>
          </FadeUp>
        </div>
      </section>

      <CTASection />

      <style>{`
        @media (max-width: 1024px) {
          .commercial-cta-grid { grid-template-columns: 1fr !important; gap: 32px !important; padding: 32px 24px !important; }
        }
        @media (max-width: 768px) {
          .commercial-cta-grid { grid-template-columns: 1fr !important; gap: 24px !important; padding: 24px 20px !important; }
        }
      `}</style>
    </PageWrapper>
  );
}
